export const routes = [
  { path: "/", breadcrumb: "Dashboard" },
  { path: "/home", breadcrumb: "Home" },
  { path: "/my-classes", breadcrumb: "My Classes" },
  { path: "/tutor-classes", breadcrumb: "Tutor's Classes" },
  { path: "/my-students", breadcrumb: "All Students" },
  { path: "/all-accounts", breadcrumb: "Parent Accounts" },
  { path: "/all-tutors", breadcrumb: "Tutor Accounts" },
  { path: "/all-tutors/create", breadcrumb: "Create Tutor Account" },
  { path: "/all-accounts/create", breadcrumb: "Create Parent Account" },
  { path: "/all-tutors/applications", breadcrumb: "Tutor Applications" },
  { path: "/assigned-classes", breadcrumb: "Assigned Classes" },
  { path: "/private-schedule", breadcrumb: "Private Classes" },
  { path: "/languages/create-language", breadcrumb: "Add New Language" },
  { path: "/languages", breadcrumb: "System Languages" },
  { path: "/class-groups", breadcrumb: "Class Groups" },
  { path: "/class-groups/create", breadcrumb: "Create New" },
  { path: "/create-child", breadcrumb: "Add New Child Account" },
  { path: "/manage-child", breadcrumb: "Manage Children Accounts" },
  { path: "/private-schedule/create-class", breadcrumb: "Create New Class" },
  { path: "/assigned-classes/tasks", breadcrumb: "Class Tasks" },
  { path: "/assigned-classes/tasks/create-task", breadcrumb: "Create New Task" },
  { path: "/timetable", breadcrumb: "My Timetable" },
  { path: "/enroll", breadcrumb: "Join a Class" },
  { path: "/child-profile", breadcrumb: "View Child Profile" },
  { path: "/materials-inventory", breadcrumb: "Shop Inventory" },
  { path: "/upload-materials", breadcrumb: "Add to Shop" },
  { path: "/enroll/confirm-enrollment", breadcrumb: "Confirm Group Classes" },
  { path: "/enroll/confirm-private-enrollment", breadcrumb: "Confirm Private Classes" },
  { path: "/ai/assistant", breadcrumb: "Assistant" },
  { path: "/ai", breadcrumb: "Office" },
  { path: "/my-profile", breadcrumb: "My Profile" },
  { path: "/shop-sales", breadcrumb: "Shop Sales" },
  { path: "/revenue", breadcrumb: "Revenue Overview" },
  { path: "/revenue/group-subs", breadcrumb: "Group Classes Revenue" },
  { path: "/revenue/private-subs", breadcrumb: "Private Classes Revenue" },
  { path: "/subscriptions", breadcrumb: "My Subscriptions" },
  { path: "/admin-accounts", breadcrumb: "Admin Accounts" },
  { path: "/admin-accounts/create", breadcrumb: "Create New Admin" },
  { path: "/earnings", breadcrumb: "Tutor Earnings" },
];